import styled from 'styled-components';

export const YearlyBadge = styled.div`
  display: flex;
  padding: 10px 14px;
  align-items: flex-start;
  border-radius: 8px;
  background: rgba(149, 209, 241, 0.15);

  backdrop-filter: blur(40px);
  width: fit-content;
  color: white;

  font-family: 'Akkurat LL';
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  line-height: 100%; /* 10px */
  letter-spacing: 0.5px;
  text-transform: uppercase;
`;
